export const colors = {
  primary: '#5993BA',
  teal: {
    50: '#E8F5F7',
    100: '#CEEAEE',
    200: '#A1D7DE',
    300: '#70C2CD',
    400: '#42AEBD',
    500: '#31808B',
    600: '#286971',
    700: '#1D4D53',
    800: '#143439',
    900: '#09181A'
  },
  secondary: '#745C42',
  amber: {
    50: '#F9F1E6',
    100: '#F4E5D1',
    200: '#E9C9A0',
    300: '#DEB072',
    400: '#D39341',
    500: '#B17629',
    600: '#8D5E21',
    700: '#6C4819',
    800: '#462F10',
    900: '#251909'
  },
  red: {
    50: '#F6EAEE',
    100: '#EED8E0',
    200: '#DBAEBE',
    300: '#C9879F',
    400: '#B86181',
    500: '#9A4564',
    600: '#7B3750',
    700: '#5C293C',
    800: '#3C1B27',
    900: '#200E15'
  },
  gray: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827'
  },
  black: '#000',
  white: '#fff',
  blue: {
    50: "#EDF3F8",
    100: "#DFEAF2",
    200: "#BED5E4",
    300: "#9ABDD5",
    400: "#7AA8C8",
    500: "#5993BA",
    600: "#40779B",
    700: "#305873",
    800: "#213D4F",
    900: "#101E28",
    950: "#070E12"
  },
  green: {
    50: '#F0F5F1',
    100: '#E1EAE2',
    200: '#C3D5C5',
    300: '#A5C0A8',
    400: '#87AB8B',
    500: '#68966E',
    600: '#547858',
    700: '#3F5A42',
    800: '#2A3C2C',
    900: '#151E16',
    950: '#0A0F0B'
  },
  indigo: {
    50: '#F3F2F7',
    100: '#E4E2EE',
    200: '#CDC9DE',
    300: '#B2ACCD',
    400: '#9890BC',
    500: '#7F75AC',
    600: '#61568F',
    700: '#49416C',
    800: '#312C49',
    900: '#181523'
  },
  rose: {
    50: '#F9ECEE',
    100: '#F3DDE1',
    200: '#E8BBC2',
    300: '#DC98A4',
    400: '#D07685',
    500: '#C45265',
    600: '#A7394B',
    700: '#7D2B39',
    800: '#541D26',
    900: '#2A0E13'
  },
  orange: {
    50: '#FCF1E9',
    100: '#F8DFCE',
    200: '#F0C09D',
    300: '#E9A06D',
    400: '#E2813C',
    500: '#C9651E',
    600: '#A05018',
    700: '#783C12',
    800: '#50280C',
    900: '#281406'
  },
  purple: {
    50: '#F4F3F8',
    100: '#E6E3ED',
    200: '#CEC7DA',
    300: '#B4A9C6',
    400: '#9B8DB3',
    500: '#8272A1',
    600: '#655783',
    700: '#483D65',
    800: '#2B2447',
    900: '#0E0B24'
  },
  slate: {
    50: '#F8FAFC',
    100: '#F1F5F9',
    200: '#E2E8F0',
    300: '#CBD5E1',
    400: '#94A3B8',
    500: '#64748B',
    600: '#475569',
    700: '#334155',
    800: '#1E293B',
    900: '#0F172A',
    950: '#080F1C'
  },
  stone: {
    50: '#FAFAF9',
    100: '#F5F5F4',
    200: '#E7E5E4',
    300: '#D4D4D4',
    400: '#A1A1AA',
    500: '#71717A',
    600: '#52525B',
    700: '#40404A',
    800: '#27272A',
    900: '#18181B',
    950: '#0A090A'
  },
  emerald: {
    50: '#EAF6EF',
    100: '#D4EDE0',
    200: '#A6D9BE',
    300: '#7BC79E',
    400: '#4CB37C',
    500: '#3A885E',
    600: '#2E6B4A',
    700: '#235239',
    800: '#173625',
    900: '#0C1D14',
    950: '#060E0A'
  }
}
